module.exports = __webpack_public_path__ + "img/polaris.d2af1783.png";